import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-board',
  templateUrl: './help-board.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpBoardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
